import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import AboutHeroSection from '../../components/User/About/AboutHeroSection'
import CreativeServicesSection from '../../components/User/About/Creativeservicessection'
// import FAQWithImageSection from '../../components/User/About/Faqwithimagesection'
import ProcessSection from '../../components/User/About/ProcessSection'
import KGSCards from '../../components/User/About/Kgscards'

const About = () => {
  return (
    <div>
      <SimpleBanner title='About Us' subheading='Home > About Us' />
      <AboutHeroSection/>
      <CreativeServicesSection/>
      <KGSCards/>
      {/* <ProcessSection/> */}
    </div>
  )
}

export default About
